(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

  exports.Controller = (function() {
    function Controller(scope, transitions) {
      this.scope = scope;
      this.transitions = transitions;
      this.loadScopeData = bind(this.loadScopeData, this);
      this.parseMentions = bind(this.parseMentions, this);
      this.parseMimeType = bind(this.parseMimeType, this);
      this.getUnsetRows = bind(this.getUnsetRows, this);
      this.clearAlert = bind(this.clearAlert, this);
      this.setAlert = bind(this.setAlert, this);
      this.setPreloadState = bind(this.setPreloadState, this);
      this.setPreloadMsg = bind(this.setPreloadMsg, this);
      this.validate = bind(this.validate, this);
      if (this.preload_on_state_change == null) {
        this.preload_on_state_change = true;
      }
      this._alert_timeout_id = null;
      this.scope.absolute_errors = false;
      this.scope.alert_message = '';
      this.scope.alert_type = '';
      this.scope.alert_details = [];
      this.scope.preloader_message = '';
      this.scope.show_preloader = false;
      this.scope.show_fullpage = true;
      this.scope.setAlert = this.setAlert;
      this.scope.clearAlert = this.clearAlert;
      this.scope.setPreloadMsg = this.setPreloadMsg;
      this.scope.getUnsetRows = this.getUnsetRows;
      this.scope.parseMimeType = this.parseMimeType;
      this.scope.save = this.save;
      this.scope.instance = this;
      if (this.preload_on_state_change) {
        this.transitionStart = this.transitions.onStart({}, (function(_this) {
          return function($transition) {
            if (_this.scope.preloader_message) {
              return _this.setPreloadState(true);
            }
          };
        })(this));
        this.transitionSuccess = this.transitions.onSuccess({}, (function(_this) {
          return function($transition) {
            if (_this.scope.preloader_message) {
              return _this.setPreloadState(false);
            }
          };
        })(this));
      }
      this.scope.$on('$destroy', (function(_this) {
        return function() {
          if (typeof _this.transitionStart === "function") {
            _this.transitionStart();
          }
          return typeof _this.transitionSuccess === "function" ? _this.transitionSuccess() : void 0;
        };
      })(this));
    }

    Controller.prototype.validate = function(event, args) {
      if (typeof this.save === 'function') {
        return this.save(true);
      }
    };

    Controller.prototype.setPreloadMsg = function(msg) {
      if (msg != null ? msg.length : void 0) {
        return this.scope.preloader_message = msg;
      } else {
        return this.scope.preloader_message = '';
      }
    };

    Controller.prototype.setPreloadState = function(show) {
      return this.scope.show_preloader = show;
    };

    Controller.prototype.setAlert = function(json_status, details, timeout, force_clear) {
      var ref, ref1;
      if (details == null) {
        details = [];
      }
      if (timeout == null) {
        timeout = null;
      }
      if (force_clear == null) {
        force_clear = false;
      }
      if ((json_status != null ? (ref = json_status.msg) != null ? ref.length : void 0 : void 0) || details.length) {
        this.scope.alert_message = json_status.msg;
        this.scope.alert_type = json_status.type;
        this.scope.alert_details = details;
        if (this._alert_timeout_id != null) {
          clearTimeout(this._alert_timeout_id);
          this._alert_timeout_id = null;
        }
        if (timeout == null) {
          if (((ref1 = json_status.type) === 'success' || ref1 === 'info') || force_clear) {
            timeout = 2000;
          } else {
            timeout = false;
          }
        }
        if (timeout !== false) {
          return this._alert_timeout_id = setTimeout((function(_this) {
            return function() {
              _this.clearAlert();
              return _this.scope.$apply();
            };
          })(this), timeout);
        }
      } else {
        return this.clearAlert();
      }
    };

    Controller.prototype.clearAlert = function() {
      this.scope.alert_message = '';
      this.scope.alert_type = '';
      this.scope.alert_details = [];
      if (this._alert_timeout_id != null) {
        clearTimeout(this._alert_timeout_id);
        return this._alert_timeout_id = null;
      }
    };

    Controller.prototype.refresh = function() {
      var params;
      params = $.extend({}, this.state.params);
      return this.state.go(this.state.current, params);
    };


    /* Useful functions used lots of places */

    Controller.prototype.getUnsetRows = function(list, length) {
      var new_length;
      if (typeof list !== 'undefined') {
        list = $.map(list, (function(_this) {
          return function(v, k) {
            return v;
          };
        })(this));
        new_length = length - list.length;
      } else {
        new_length = length;
      }
      if (new_length >= 0) {
        return new Array(new_length);
      } else {
        return new Array(0);
      }
    };

    Controller.prototype.parseMimeType = function(mime) {
      var pattern;
      if ((mime != null) && mime !== '') {
        pattern = /^(.*?)\//;
        mime = mime.match(pattern)[0];
        return mime;
      } else {
        return null;
      }
    };

    Controller.prototype.parseMentions = function(text, mentionable) {
      var i, len, match, new_mentions, regex, user;
      regex = /(^|\s)@((?:[^\s\.,!;])+)/g;
      match = regex.exec(text);
      new_mentions = [];
      while (match !== null) {
        for (i = 0, len = mentionable.length; i < len; i++) {
          user = mentionable[i];
          if (user.username === match[2] && new_mentions.indexOf(user) === -1) {
            new_mentions.push(user);
            break;
          }
        }
        match = regex.exec(text);
      }
      return new_mentions;
    };

    Controller.prototype.loadScopeData = function(promise, key) {
      promise.then((function(_this) {
        return function(response) {
          var ref, ref1;
          if ((response != null ? (ref = response.data) != null ? (ref1 = ref.status) != null ? ref1.type : void 0 : void 0 : void 0) === 'success') {
            return _this.scope[key] = response.data.data;
          }
        };
      })(this));
      return promise;
    };

    return Controller;

  })();

}).call(this);
